import AssistantMessageOverflowMenu from './AssistantMessageOverflowMenu'
import AssistantMessageRetryMenu from './AssistantMessageRetryMenu'

export default function AssistantMessageContentMenus({
  vm,
  handlers,
  onTryAgain,
  onThinkLonger,
  onSearchWeb,
  text,
}) {
  return (
    <>
      <AssistantMessageRetryMenu
        retryMenuId={vm.retryMenuId}
        retryAnchorEl={vm.retryAnchorEl}
        retryOpen={vm.retryOpen}
        onClose={handlers.handleCloseRetryMenu}
        onTryAgain={onTryAgain}
        onThinkLonger={onThinkLonger}
        onSearchWeb={onSearchWeb}
      />
      <AssistantMessageOverflowMenu
        menuId={vm.menuId}
        menuAnchorEl={vm.menuAnchorEl}
        menuOpen={vm.menuOpen}
        onClose={handlers.handleCloseMenu}
        onNotes={handlers.handleAddToNotes}
        onReadAloud={handlers.handleReadAloud}
        text={text}
        canSpeak={vm.canSpeak}
      />
    </>
  )
}
